export const TABLE_TAXONOMY = {
	firm: [
		{field: 'company_name', t: 'billing_info', relatedKeys: 'id', rowStyle: 'array'},
		{field: 'status', rowStyle: 'status'},
		{field: 'organisation', relatedKeys: 'organisation_id', rowStyle: 'array'},
		{field: 'environments', rowStyle: 'array', relatedKeys: 'environment_ids'},
	],
	payment_details: [
		{
			field: 'mollie_mandate',
			rowStyle: 'boolean',
			infoIconMessage: {title: 'records.default.fields.mollie_mandate', body: 'tooltips.mollie_mandate'},
		},
		{field: 'emails', t: 'invoice_emails', rowStyle: 'array'},
		{field: 'vat_number'},
		{field: 'account_nr'},
		{field: 'account_name'},
		{field: 'account_bic'},
		{field: 'card_issuer'},
	],
	pricing_agreement: [
		{field: 'note', infoIconMessage: {title: 'records.default.fields.note', body: 'tooltips.note'}},
		{
			field: 'ignore_mollie',
			rowStyle: 'boolean',
			infoIconMessage: {title: 'records.default.fields.ignore_mollie', body: 'tooltips.ignore_mollie'},
		},
		{
			field: 'ignore_vat',
			rowStyle: 'boolean',
			infoIconMessage: {title: 'records.default.fields.ignore_vat', body: 'tooltips.ignore_vat'},
		},
		{field: 'first_billing_date', rowStyle: 'date'},
		{field: 'discount_pct'},
		{field: 'discount_amt_per_user'},
		{field: 'fixed_amt_per_env'},
		{field: 'fixed_amt_per_user'},
	],
	billing_information: [
		{field: 'country', rowStyle: 'capitalize'},
		{field: 'city'},
		{field: 'street'},
		{field: 'house_number'},
		{field: 'postal_code'},
	],
	contract_information: [
		{field: 'pdf', t: 'contract_pdf', rowStyle: 'link'},
		{field: 'signer_name'},
		{field: 'signed_at', rowStyle: 'date', format: "D MMM 'YY [at] HH:mm"},
	],
}
